import React, { FC, useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import { styled } from '@material-ui/styles';

import { BillingStepEnum } from '../../constants/billing';

const IFrameWrapper = styled(Box)((props: {
    modalWidth?: number,
    modalHeight?: number,
    billingStep: BillingStepEnum,
}) => ({
    width: props.modalWidth ? `${props.modalWidth}px` : '100vw',
    height: props.modalHeight ? `${props.modalHeight}px` : '100vh',
    overflow: (
        (props.billingStep === BillingStepEnum.UPCOMING_DISPLAY_INVOICE) ||
        (props.billingStep === BillingStepEnum.UPCOMING_CELLULAR_INVOICE) ||
        (props.billingStep === BillingStepEnum.UPCOMING_ANALYTICS_INVOICE) ?
        'auto' : 'hidden'
    ),
    borderRadius: '8px',
}));

const modalSizes = {
    [BillingStepEnum.CHOOSE_PLAN]: {
        width: 732,
        height: 717,
    },
    [BillingStepEnum.PRO_PAYMENT]: {
        width: 723,
        height: 634,
    },
    [BillingStepEnum.STANDARD_PAYMENT]: {
        width: 723,
        height: 634,
    },
    [BillingStepEnum.DOWNGRADE_CONFIRM]: {
        width: 580,
        height: 399,
    },
    [BillingStepEnum.CANCEL_DISPLAY_CONFIRM]: {
        width: 580,
        height: 285,
    },
    [BillingStepEnum.CANCEL_CELLULAR_CONFIRM]: {
        width: 580,
        height: 229,
    },
    [BillingStepEnum.FINAL]: {
        width: 580,
        height: 211,
    },
    [BillingStepEnum.CANCEL_DISPLAY_FINAL]: {
        width: 580,
        height: 211,
    },
    [BillingStepEnum.CANCEL_CELLULAR_FINAL]: {
        width: 580,
        height: 211,
    },
    [BillingStepEnum.DOWNGRADE_FINAL]: {
        width: 580,
        height: 187,
    },
    [BillingStepEnum.CHANGE_DISPLAY_QUANTITY]: {
        width: 581,
        height: 642,
    },
    [BillingStepEnum.UPCOMING_DISPLAY_INVOICE]: {
        width: 580,
        height: undefined,
    },
    [BillingStepEnum.UPCOMING_CELLULAR_INVOICE]: {
        width: 580,
        height: undefined,
    },
    [BillingStepEnum.UPCOMING_ANALYTICS_INVOICE]: {
        width: 580,
        height: undefined,
    },
};

export const RemotePriceTable: FC<{
    firstPageIsConfirmPayment?: boolean,
    goesToDescriptionPage?: () => void,
    onClose?: () => void;
}> = ({
    firstPageIsConfirmPayment,
    goesToDescriptionPage,
    onClose,
}) => {
    const [billingStep, setBillingStep] = useState(() => (firstPageIsConfirmPayment ? BillingStepEnum.PRO_PAYMENT : BillingStepEnum.CHOOSE_PLAN));
    const [modalHeight, setModalHeight] = useState(modalSizes[billingStep]?.height);
    const [modalWidth, setModalWidth] = useState(modalSizes[billingStep]?.width);

    window.addEventListener('message', (event) => {
        const { eventName, data } = event.data;

        if (eventName === 'updateBillingStep') {
            setBillingStep(data?.billingStep);
        }

        if (eventName === 'updateRemoteDialogSize') {
            data?.height && setModalHeight(data?.height);
            data?.width && setModalWidth(data?.width);
        }

        if (eventName === 'goReviousPage') {
            goesToDescriptionPage && goesToDescriptionPage();
        }

        if ((eventName === 'closeRemoteDialog') && (data?.status === 'done') && onClose) {
            onClose();
        }
    });

    useEffect(() => {
        let size = modalSizes[billingStep];

        setModalWidth(size?.width);
        setModalHeight(size?.height);
    }, [billingStep, setModalWidth, setModalHeight]);

    const queryParams = new URLSearchParams({
        billingStep: BillingStepEnum.PRO_PAYMENT,
    });
    const modalUrl = firstPageIsConfirmPayment ?
        `${process.env.REACT_APP_SCREENHUB_CONTROL_URL}/billing/manage-display-plan?${queryParams.toString()}` :
        `${process.env.REACT_APP_SCREENHUB_CONTROL_URL}/billing/manage-display-plan`;

    return (
        <IFrameWrapper
            modalWidth={modalWidth}
            modalHeight={modalHeight}
            billingStep={billingStep}
        >
            <iframe
                src={modalUrl}
                title="manage-plan"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    overflow: (
                        (billingStep === BillingStepEnum.UPCOMING_DISPLAY_INVOICE) ||
                        (billingStep === BillingStepEnum.UPCOMING_CELLULAR_INVOICE) ||
                        (billingStep === BillingStepEnum.UPCOMING_ANALYTICS_INVOICE) ?
                        'auto' : 'hidden'
                    ),
                }}
            />
        </IFrameWrapper>
    );
}